import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import LoadMoreList from "../../../services/LoadMoreList";
import { convertToOriginalForm } from "../../../services/StringOperation";

const AppliedJobsList = ({ jobTypeParam, ...props }) => {
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [setFilter] = useState("");
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const filteredJobs = props.appliedjobs.filter(
      (job) =>
        job.cnd_permanent_job_status ===
        (jobTypeParam ? jobTypeParam : "Applied")
    );
    setAppliedJobs(filteredJobs);
  }, [props.appliedjobs, jobTypeParam]);

  const matchesSearchText = (job) => {
    const searchText = inputValue.toLowerCase();
    return (
      job.users_firstname.toLowerCase().includes(searchText) ||
      job.users_lastname.toLowerCase().includes(searchText) ||
      job.cnd_permanent_job_title.toLowerCase().includes(searchText) ||
      job.cnd_permanent_job_status.toLowerCase().includes(searchText) ||
      format(new Date(job.cnd_permanent_job_created_date), "dd-MM-yyyy")
        .toLowerCase()
        .includes(searchText)
    );
  };

  // Filter applied jobs based on the search text
  const filteredJobs = appliedJobs ? appliedJobs.filter(matchesSearchText) : [];
  // let checkData = filteredJobs.length > 10;

  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        <div className="container">
          <div className="row">
            {/* <div className="col-sm-6"></div> */}
            <div className="col-sm-12">
              <div className="form-group form-group-default">
                <input
                  type="text"
                  name="search"
                  className="form-control "
                  placeholder="Enter here"
                  id="myInput"
                  onInput={(event, value) => {
                    setInputValue(event.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <LoadMoreList
          data={filteredJobs}
          initialCount={5}
          noDataMessage="No Result Found"
          renderItem={(appliedJob, i) => (
            <ul
              className="nav navbar-nav border border-grey p-4 mb-2"
              style={{ borderRadius: "20px" }}
              key={i}
            >
              <li className="text-dark">
                <i className="fa fa-user-circle mr-1 text-primary"></i>{" "}
                {appliedJob.users_firstname + " " + appliedJob.users_lastname}
              </li>
              <li className="text-dark">
                <i className="fa fa-calendar-o mr-1 text-primary"></i>{" "}
                {format(
                  new Date(appliedJob.cnd_permanent_job_created_date),
                  "dd-MM-yyyy"
                )}
              </li>
              <li className="text-dark">
                <i className="fa fa-suitcase mr-1 text-primary"></i>{" "}
                {convertToOriginalForm(appliedJob.cnd_permanent_job_title)}
              </li>
              <li className="text-dark">
                <i className="fa fa-circle-o-notch mr-1 text-primary"></i>{" "}
                {appliedJob.cnd_permanent_job_status}
              </li>
            </ul>
          )}
        />
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    appliedjobs: state.appliedjobs.appliedjobs,
  };
};

export default connect(mapStateToProps)(AppliedJobsList);
